
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "crop-image"
})
export default class CropImageComponent extends Vue {
  @Prop({ default: "" }) imageSrc!: string;
  @Prop({ default: 400 }) maxHeight!: number;
  @Prop({ default: 450 }) maxWidth!: number;

  get imageStyle(): Record<string, string> {
    return {
      maxHeight: this.maxHeight + "px",
      maxWidth: this.maxWidth + "px"
    };
  }

  @Watch("imageSrc")
  onImageSrcChanged() {
    this.$nextTick(() => this.emitCurrentCrop());
  }

  emitCurrentCrop() {
    const image = this.$refs.image as HTMLImageElement | undefined;
    if (!image) {
      return;
    }

    this.$emit("update", {
      width: image.naturalWidth || image.width || 0,
      height: image.naturalHeight || image.height || 0,
      top: 0,
      left: 0
    });
  }

  forceUpdate() {
    this.emitCurrentCrop();
  }
}
